import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input, output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { AvailabilityRoomStatus, ProductRoomAvailability, RoomAvailability } from '../../bag-transport-term.model';

@Component({
	selector: 'app-bag-transport-term-room-availabilities',
	standalone: true,
	imports: [CommonModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatInputModule],
	templateUrl: './bag-transport-term-room-availabilities.component.html',
	styleUrl: './bag-transport-term-room-availabilities.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BagTransportTermRoomAvailabilitiesComponent implements OnInit {
	termId = input.required<number>();
	rooms = input<RoomAvailability[]>([]);

	roomAvailabilityChanged = output<ProductRoomAvailability>();
	roomAvailabilityCanceled = output<void>();
	roomAvailabilityEdit = output<RoomAvailability>();

	form: FormGroup;

	readonly AvailabilityRoomStatus = AvailabilityRoomStatus;

	private readonly formBuilder = inject(FormBuilder);

	ngOnInit(): void {
		this.prepareExpectedAvailabilitiesForm();
	}

	changeRoomAvailability(room: RoomAvailability): void {
		this.form.markAllAsTouched();
		if (!this.form.valid) {
			return;
		}
		const dataToSend: ProductRoomAvailability = {
			roomType: room.id,
			term: this.termId(),
			expectedAvailabilities: this.form.controls.expectedAvailability.value,
		};

		this.roomAvailabilityChanged.emit(dataToSend);
		this.clearForm();
		room.mode = AvailabilityRoomStatus.DISABLED;
	}

	cancelRoomAvailability(): void {
		this.roomAvailabilityCanceled.emit();
		this.clearForm();
	}

	editRoomAvailability(room: RoomAvailability): void {
		const control = this.form.get('expectedAvailability');
		if (control) {
			control.setValue(room.count);
		}
		this.roomAvailabilityEdit.emit(room);
	}

	private prepareExpectedAvailabilitiesForm(): void {
		this.form = this.formBuilder.group({
			expectedAvailability: [0, Validators.required],
		});
	}

	private clearForm(): void {
		this.form.reset();
	}
}
